import { render, staticRenderFns } from "./RefundOrderList.vue?vue&type=template&id=3bff4178&scoped=true"
import script from "./RefundOrderList.vue?vue&type=script&lang=js"
export * from "./RefundOrderList.vue?vue&type=script&lang=js"
import style0 from "./RefundOrderList.vue?vue&type=style&index=0&id=3bff4178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff4178",
  null
  
)

export default component.exports